<button
  psUiButton
  class="header-div-h6 position-relative header-dropdown"
  [class.show]="!!headerFeasibility && headerFeasibility.isOpen"
  [ngClass]="{ 'dropdown-toggle': !(isMultiCountrySelected && !isDraftSaved) }"
  color="secondary"
  [disabled]="!feasibilityQuota.length"
  [psUiDropdownToggleFor]="headerFeasibility"
  psUiGtagEvent
  trackOn="click"
  action="feasibility"
  category="Black_Bar"
  [params]="{ event_label: 'Feasibility Dropdown' }"
>
  {{
    isMultiCountrySelected && !isDraftSaved
      ? Constants.TOTAL_FEASIBILITY
      : Constants.FEASIBILITY
  }}
  <span
    *ngIf="feasibilityStatus !== 'none'"
    [ngClass]="'bg-' + feasibilityStatus"
    class="position-absolute translate-middle p-2 bg-success badge-ball border border-light rounded-circle margin-left"
  >
    <span class="visually-hidden">New alerts</span>
  </span>
</button>
<ps-ui-dropdown #headerFeasibility="psUiDropdown" class="header-dropdown">
  <div class="text-center fw-bold title">
    Audience:
    <p class="default-quotas m-0 text-center fw-normal">
      <span *ngFor="let a of audience; let last = last">
        {{ a }}<span class="me-1" *ngIf="!last">, </span>
      </span>
    </p>
  </div>
  <div class="row w-100 m-0 py-1 header">
    <div class="col header-category">Condition</div>
    <div class="col">Feasible/Desired</div>
  </div>
  <div
    class="item py-2"
    *ngFor="let f of feasibilityQuota | sort : 'qualificationCode'"
  >
    <label class="fw-bold">{{ f.name }}</label>
    <p *ngIf="f.showQualificationMessage" class="feasibility-message">
      Population Data is Unavailable
    </p>
    <div
      class="row body mx-2 px-1 p-1 mb-0"
      [class.alert-danger]="!q.feasible"
      *ngFor="let q of f.quotas"
    >
      <div class="col condition-feasibility" title="{{ q.range }}">
        {{ q.range }}
      </div>
      <div class="col text-end">
        {{ q.feasibility }}
      </div>
    </div>
  </div>
</ps-ui-dropdown>
<div class="mb-0">
  <span *ngIf="!loading" class="header-div-span">
    {{ totalFeasibility | number }}
  </span>
  <ps-ui-ellipsis-loader [show]="loading"> </ps-ui-ellipsis-loader>
</div>
